<script>
  import {faceTrackingStore} from '../../../store';
</script>

{#if $faceTrackingStore.faceSelection}
  <div class="absolute left-0 top-0 flex h-full w-full items-center justify-center">
    <div class="absolute left-0 top-0 z-[1000] h-full w-full bg-gray-500 opacity-50"></div>
    <div class="relative z-[2000]">
      <div class="rounded-md bg-white p-4">
        <div class="flex items-center">Facial Encodings Selector</div>
      </div>
    </div>
  </div>
{/if}
